import { createCustomElement } from '@angular/elements';
import { createApplication } from '@angular/platform-browser';
import { WebchatMultiLocationRootComponent } from './app/components/webchat-multi-location-root/webchat-multi-location-root.component';
import { WebchatRootComponent } from './app/components/webchat-root/webchat-root.component';

(async () => {
  const { appConfig } = await import('./app/app.config');

  const app = await createApplication({
    providers: appConfig.providers,
  });

  const webchatRootElement = createCustomElement(WebchatRootComponent, {
    injector: app.injector,
  });
  customElements.define('webchat-root', webchatRootElement);

  const webchatMultiLocationRootElement = createCustomElement(WebchatMultiLocationRootComponent, {
    injector: app.injector,
  });
  customElements.define('webchat-multi-location-root', webchatMultiLocationRootElement);
})();
